import * as React from "react"

function SvgSocialMediaFacebook(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 22 22"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
        d="M11.435 21H1.87a.87.87 0 01-.87-.87V1.87c0-.48.39-.87.87-.87h18.26c.48 0 .87.39.87.87v18.26c0 .48-.39.87-.87.87h-5.217v-7.826h2.225a.434.434 0 00.435-.381l.326-2.609a.435.435 0 00-.435-.488h-2.551V8.552c0-.81.657-1.464 1.466-1.465h1.578c.24 0 .434-.195.434-.435V4.043a.435.435 0 00-.434-.434h-1.578a4.949 4.949 0 00-4.944 4.943v1.144H9.26a.435.435 0 00-.435.434v2.61c0 .24.195.434.435.434h2.174V21z"
      />
    </svg>
  )
}

export default SvgSocialMediaFacebook
